
import { keyEscape } from '../helpers'
import { gsap } from 'gsap'

class Accordion {
	constructor(el, options) {
		const defaults = {
			closeSiblings: false
		}

		const populatedDefaults = Object.assign(defaults, options)
		for (const key in populatedDefaults) {
			if (Object.prototype.hasOwnProperty.call(populatedDefaults, key)) {
				this[key] = populatedDefaults[key]
			}
		}

		// Store all relevant DOM nodes of Component
		this.el = el
		this.accordionTab = this.el.querySelector('details')
		this.summary = this.accordionTab.querySelector('summary')
		this.drawer = this.accordionTab.querySelector('details > div')
		this.el.expandIcon = new ExpandIcon(this.el)
		this.accordionTab.querySelector('expand-icon')

		// Store if the element is closing
		this.isClosing = false
		// Store if the element is expanding
		this.isExpanding = false

		// Store the animation object (so we can cancel it if needed)
		this.timeline = gsap.timeline()

		this.summary.addEventListener('click', (e) => this.onClick(e))
	}

	onClick(e) {
		// Stop default behaviour from the browser
		e.preventDefault()
		// Add an overflow on the <details> to avoid content overflowing
		this.accordionTab.style.overflow = 'hidden'
		// Check if the element is being closed or is already closed
		if (this.isClosing || !this.accordionTab.open) {
			// !this.closeOthers();
			this.open()
			// Check if the element is being openned or is already open
		} else if (this.isExpanding || this.accordionTab.open) {
			this.shrink()
		}
	}

	open() {
		// Apply a fixed height on the element
		this.accordionTab.style.height = `${this.accordionTab.offsetHeight}px`
		// Force the [open] attribute on the details element
		this.accordionTab.open = true
		// Wait for the next frame to call the expand function
		window.requestAnimationFrame(() => this.expand())
	}

	shrink() {
		// Set the element as "being closed"
		this.isClosing = true

		// Calculate the height of the summary
		const endHeight = `${this.summary.offsetHeight}px`

		// If there is already an animation running
		if (this.timeline.isActive()) {
			// Cancel the current animation
			this.timeline.pause()
		}

		this.timeline.to(this.accordionTab,
			{
				height: endHeight,
				duration: 0.3,
				ease: 'Power1.inOut',
				onComplete: () => this.onAnimationFinish(false),
				onInterrupt: () => this.isClosing = false
			}
		)

		if (this.el.expandIcon) this.el.expandIcon.shrink()
	}

	expand() {
		// Set the element as "being expanding"
		this.isExpanding = true

		// If there is already an animation running
		if (this.timeline.isActive()) {
			// Cancel the current animation
			this.timeline.pause()
		}
		// Calculate the open height of the element (summary height + content height)
		const endHeight = `${this.summary.offsetHeight + this.drawer.offsetHeight}px`

		this.timeline.to(this.accordionTab, {
			height: endHeight,
			duration: 0.3,
			ease: 'Power1.inOut',
			onComplete: () => this.onAnimationFinish(true),
			onInterrupt: () => this.isExpanding = false
		})

		if (this.el.expandIcon) this.el.expandIcon.expand()

		if (this.closeSiblings) this.closeOthers()
	}

	onAnimationFinish(open) {
		// Set the open attribute based on the parameter
		this.accordionTab.open = open
		// Reset isClosing & isExpanding
		this.isClosing = false
		this.isExpanding = false
		// Remove the overflow hidden and the fixed height
		this.accordionTab.style.height = this.accordionTab.style.overflow = ''
	}

	closeOthers() {


		const openTabs = Array.from(document.querySelectorAll('[data-accordion] details[open]'))

		openTabs.map(el => {
			// Don't close CURRENT EL of course
			if (el === this.accordionTab) return

			el.style.overflow = 'hidden'

			const thisSummary = el.querySelector('summary')
			const endHeight = `${thisSummary.offsetHeight}px`

			gsap.to(el, {
				height: endHeight,
				duration: 0.3,
				ease: 'Power1.inOut',
				onComplete: () => {
					el.open = false
					el.style.height = el.style.overflow = ''
					// this.accordionTab.open = false
				}
			})
			if (el.closest('[data-accordion]')?.expandIcon) el.closest('[data-accordion]').expandIcon.shrink()
		})
	}
}

class ExpandIcon {
	constructor(el, options) {
		// base for further abstraction if we want different
		// expansion icons which could be set via theme editor
		// right now its just set up for a plus that
		// animates into a minus on expansion
		this.el = el.querySelector('.details-indicator')
		this.verticalLine = this.el.querySelector('.vertical')

		gsap.set(this.verticalLine, { transformOrigin: '50% 50%', rotation: 90 })
	}

	expand() {
		gsap.to(this.verticalLine, {
			rotation: 0,
			duration: 0.3,
			ease: 'Power2.inOut'
		})
	}

	shrink() {
		gsap.to(this.verticalLine, {
			rotation: 90,
			duration: 0.3,
			ease: 'Power2.inOut'
		})
	}
}

(function init() {
	const accordionEls = document.querySelectorAll('[data-accordion]')

	accordionEls.forEach((el, i, arr) => {
		if (el.getAttribute('bound') !== null) return

		const accordion = new Accordion(el, { closeSiblings: true })

		el.setAttribute('bound', '')

		const id = arr.length > 1 ? `accordion_${i}` : 'accordion'

		self.Decimal.components[id] = { ...accordion, async: true }
	})
})()

export {
	Accordion,
	ExpandIcon
}
